/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Home ownership.   (german: Wohneigentum)   (bipro-datentypen::Wohneigentum)     * `None`  - no ownership   * `Flat`  - owner occupied flat (german: selbstgenutzte Wohnung)   * `House` - owner occupied house (german: selbstgenutztes Haus)   * `NotSpecified` - ownership not specified (german: keine Angabe)
 */
export const HomeOwnershipKind = {
  None: 'None',
  Flat: 'Flat',
  House: 'House',
  NotSpecified: 'NotSpecified',
} as const;
export type HomeOwnershipKind = (typeof HomeOwnershipKind)[keyof typeof HomeOwnershipKind];
